__turbopack_context__.v({
  "className": "outfit_92759770-module__3q_Spa__className",
  "variable": "outfit_92759770-module__3q_Spa__variable",
});
